/* GlobifySIM – allgemeine Oberfläche */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    /* Menü auf kleinen Bildschirmen */
    var schalter = document.querySelector("[data-gs-menue]");
    var navi = document.querySelector("[data-gs-navi]");
    if (schalter && navi) {
      schalter.addEventListener("click", function () {
        var offen = navi.classList.toggle("ist-offen");
        schalter.setAttribute("aria-expanded", offen ? "true" : "false");
      });
    }

    /* Anker weich anspringen, Kopfhöhe abziehen */
    document.addEventListener("click", function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var id = a.getAttribute("href");
      if (!id || id === "#") return;
      var ziel = document.querySelector(id);
      if (!ziel) return;
      e.preventDefault();
      var kopf = document.querySelector(".gs-kopf");
      var abzug = kopf ? kopf.offsetHeight + 12 : 12;
      var y = ziel.getBoundingClientRect().top + window.pageYOffset - abzug;
      window.scrollTo({ top: y, behavior: "smooth" });
      if (navi && navi.classList.contains("ist-offen")) navi.classList.remove("ist-offen");
    });

    /* Menge im Warenkorb ohne Neuladen ändern */
    var formulare = document.querySelectorAll("[data-gs-warenkorb-menge]");
    for (var i = 0; i < formulare.length; i++) {
      formulare[i].addEventListener("change", function () {
        var f = this.closest("form");
        if (f) f.submit();
      });
    }

    /* Kopiere-Knöpfe */
    var kopien = document.querySelectorAll("[data-gs-kopieren]");
    for (var k = 0; k < kopien.length; k++) {
      kopien[k].addEventListener("click", function () {
        var wert = this.getAttribute("data-gs-kopieren");
        var hinweis = this.querySelector(".gs-code__hinweis");
        if (navigator.clipboard) navigator.clipboard.writeText(wert);
        if (hinweis) {
          var vorher = hinweis.textContent;
          hinweis.textContent = this.getAttribute("data-gs-kopiert") || "Copied";
          window.setTimeout(function () { hinweis.textContent = vorher; }, 2000);
        }
      });
    }
  });
})();
